import React from "react";
import "./CustomerContactUs.scss";
import { isAutoServicesTenant } from "../../../utils/tenantBranding";

const ContactUs = ({setIsWorkshopSelectorClicked}) => {
  const fetchingTenant = window.location.hostname.split(".")[0];
  const autoServicesBranding = isAutoServicesTenant(fetchingTenant);
   
  const brandName = autoServicesBranding ? "Autoservices" : "Eurorepar";
  return (
    <div className="contact-container">
      <div className="headercustomercontactus">
        <h1>Contact Us</h1>
        <p>We're here to help with all your automotive service needs</p>
      </div>

      <div className="content">
        <div className="customer-service">
          <h2>Customer Service</h2>
          <p>
            At {brandName} Car Service, we want to offer you a friendly, local
            customer service experience. For any queries regarding bringing your
            car to us, making a booking, or any questions about servicing or
            repairing your car, it's best to speak to your local Centre first.
          </p>

          <a href="#" className="find-center-btn pulse" onClick={() => setIsWorkshopSelectorClicked(true)}>
            🔍 Find your nearest {brandName} Car Service Centre
          </a>

          <p>
            If you've already visited one of our Centres and would like to talk
            to us about any problems or concerns, you can get in touch with us
            via call or email. We'll get back to you as soon as possible.
          </p>
        </div>

        <div className="contact-methods">
          <div className="contact-card">
            <span className="contact-icon">📧</span>
            <h3>Email Support</h3>
            <div className="contact-info">
              {autoServicesBranding ? (
                <a href="mailto:connect@autoservices.in" className="contact-link">
                  connect@autoservices.in
                </a>
              ) : (
                <a href="mailto:connect@eurorepar.in" className="contact-link">
                  connect@eurorepar.in
                </a>
              )}
            </div>
          </div>

          <div className="contact-card">
            <span className="contact-icon">📞</span>
            <h3>Toll Free</h3>
            <div className="contact-info">
              {autoServicesBranding ? (
                <a href="tel:1234567890" className="contact-link">
                  1234 5678 90
                </a>
              ) : (
                <a href="tel:18002665337" className="contact-link">
                  1800 266 5337
                </a>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="note">
        <strong className="stronggg">Quick Response Guarantee:</strong> We're committed to getting
        back to you as soon as possible with the help you need!
      </div>
    </div>
  );
};

export default ContactUs;

